// src/components/Step1.js
import React, { useState } from 'react';
import { Button } from "./ui/Button";
import { Input } from "./ui/Input";
import { Label } from "./ui/Label";

const Step1 = ({ formData, updateFormData, nextStep, prevStep }) => {
  const [firstName, setFirstName] = useState(formData.firstName || '');
  const [lastName, setLastName] = useState(formData.lastName || '');
  const [businessName, setBusinessName] = useState(formData.businessName || '');
  const [businessPhone, setBusinessPhone] = useState(formData.businessPhone || '');
  const [businessEmail, setBusinessEmail] = useState(formData.businessEmail || '');
  const [businessUrl, setBusinessUrl] = useState(formData.businessUrl || '');

  const [errors, setErrors] = useState({});

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = {};

    if (Object.keys(newErrors).length === 0) {
      updateFormData({ firstName, lastName, businessName, businessPhone, businessEmail,businessUrl});
      nextStep();
    } else {
      setErrors(newErrors);
    }
  };

  return (
    <div>
      <h2 className="text-3xl font-bold mb-4 font-display">Contact Information</h2>
      <p className="mb-8 text-gray-600">
        Please enter the contact information for the primary person who will manage and
        oversee your InCall IQ onboarding. This contact will have administrative
        access to all aspects of our service and be the person we communicate with most
        frequently.
      </p>
      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <Label htmlFor="firstName">First Name</Label>
          <Input
            id="firstName"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            placeholder="Enter first name"
            required
          />
        </div>
        <div>
          <Label htmlFor="lastName">Last Name</Label>
          <Input
            id="lastName"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            placeholder="Enter last name"
            required
          />
        </div>
        <div>
          <Label htmlFor="businessName">Business Name</Label>
          <Input
            id="businessName"
            value={businessName}
            onChange={(e) => setBusinessName(e.target.value)}
            placeholder="Enter business name"
            required
          />
        </div>
         <div>
          <Label htmlFor="businessEmail">Business Email</Label>
          <Input
            id="businessEmail"
            type="email"
            value={businessEmail}
            onChange={(e) => setBusinessEmail(e.target.value)}
            placeholder="Enter business email"
            required
          />
        </div>
        <div>
          <Label htmlFor="businessPhone">Phone Number</Label>
          <Input
            id="businessPhone"
            value={businessPhone}
            onChange={(e) => setBusinessPhone(e.target.value)}
            placeholder="Enter phone number"
            required
          />
        </div>
       
        <div>
          <Label htmlFor="businessUrl">Business URL</Label>
          <Input
            id="businessUrl"
            type="text"
            value={businessUrl}
            onChange={(e) => setBusinessUrl(e.target.value)}
            placeholder="Enter business URL"
            required
          />
        </div>
        <div className="flex justify-between pt-4">
          <Button type="button" onClick={prevStep} variant="outline">Prev</Button>
          <Button type="submit">Next</Button>
        </div>
      </form>
    </div>
  );
};

export default Step1;
